import { useCallback } from 'react';
import * as MixpanelAudience from 'react/infra/mixpanel/MixpanelAudience';

const useEventHandlers = ({
  interestType,
  audienceChannel,
  segment,
  context,
  setTopic,
  setTitle,
  queryData,
  targets,
  targetsCommon,
  defineInterestModal,
  setNewlyAddedInterestsToTest,
  deleteTestedInterest,
  setInterests,
  doPublishAllInterestsToView,
}) => {
  const handleTopicChange = useCallback(
    (newTopic) => {
      if (interestType === 'categories') return;
      setTopic(newTopic);
      setTitle(newTopic.id);
      MixpanelAudience.trackAudienceExplorerTopicClick(newTopic.id, 'audience-explorer', audienceChannel);
      doPublishAllInterestsToView(true, interestType, newTopic.id);
    },
    [interestType, audienceChannel, doPublishAllInterestsToView, setTopic, setTitle]
  );

  const handleDeleteTestedInterest = useCallback(
    (id) => {
      deleteTestedInterest(id, interestType, setInterests, () => doPublishAllInterestsToView(false));
    },
    [interestType, deleteTestedInterest, setInterests, doPublishAllInterestsToView]
  );

  const handleDefineInterest = useCallback(
    (currentTags) => {
      if (!defineInterestModal) return;

      Promise.resolve(defineInterestModal.showModal(currentTags)).then((modal) => {
        modal.close.then((interest) => {
          if (interest) {
            const type = interestType === 'websites' ? 'websites' : interestType === 'phrases' ? 'phrases' : 'searches';
            setNewlyAddedInterestsToTest((prev) => ({
              ...prev,
              [type]: [...(prev[type] || []), interest],
            }));
          }
        });
      });
    },
    [defineInterestModal, interestType, setNewlyAddedInterestsToTest]
  );

  const handleOpenTargets = useCallback(() => {
    if (!targetsCommon) return;
    targetsCommon.openTargets({
      scope: { targets, currentTarget: {}, query: queryData, audienceChannel, segment, context },
    });
  }, [targetsCommon, targets, queryData, audienceChannel, segment, context]);

  return {
    handleTopicChange,
    handleDeleteTestedInterest,
    handleDefineInterest,
    handleOpenTargets,
  };
};

export default useEventHandlers;
